import {msGraphApiCall} from "./MsGraphApiCall";
import { teamsRequest, channelsRequest, messageRequest, graphConfig } from "../authConfig";

async function callMsGraphApi(url: string, scopes: string[]): Promise<any> {
    return msGraphApiCall(url, "GET", scopes);
}

export async function getTeamsChannels(filterText?: string): Promise<any[]> {
    const teamsData = await callMsGraphApi(graphConfig.graphTeamsEndpoint, teamsRequest.scopes);
    let filteredTeams = teamsData.value;
    if (filterText && filterText.trim() !== "") {
        const lowerFilter = filterText.toLowerCase();
        filteredTeams = filteredTeams.filter((team: any) =>
            team.displayName && team.displayName.toLowerCase().includes(lowerFilter)
        );
    }
    const allChannels: any[] = [];
    for (const team of filteredTeams) {
        const channelsData = await callMsGraphApi(graphConfig.graphChannelsEndpoint(team.id), channelsRequest.scopes);
        allChannels.push(...channelsData.value.map((ch: any) => ({ ...ch, teamName: team.displayName, teamId: team.id })));
    }
    return allChannels;
}

export async function sendMessageToChannel(teamId: string, channelId: string, message: string): Promise<any> {
    const url = graphConfig.graphSendMessageEndpoint(teamId, channelId);
    const body = {
        body: {
            content: message
        }
    };
    return msGraphApiCall(url, "POST", messageRequest.scopes, body);
}

export async function getChannelMessages(teamId: string, channelId: string): Promise<any[]> {
    const url = graphConfig.graphChannelMessagesEndpoint(teamId, channelId);
    const messagesData = await callMsGraphApi(url, messageRequest.scopes);
    return messagesData.value || [];
}

export async function createChannel(teamId: string, name: string, description?: string): Promise<any> {
    const url = graphConfig.graphCreateChannelEndpoint(teamId);
    const body = {
        displayName: name,
        description: description || "",
        membershipType: "standard"
    };
    return msGraphApiCall(url, "POST", channelsRequest.scopes, body);
}
